<template>
  <div class="empty-list-section">
    <div class="label-group">
      <div class="title-label">
        Selecione qual tipo de presente você gostaria de adicionar à sua lista.
      </div>
      <div class="subtitle-label">
        Lembrando que todos os presentes são fictícios e serão convertidos em
        dinheiro ;)
      </div>
    </div>
    <div class="empty-list-cards-section">
      <div
        class="empty-list-card"
        @click="openDrawer(giftCreateInfo, 'DrawerCreateGift')"
      >
        <div class="imgGroup"><img :src="createGiftImg" /></div>
        <div class="titleGroup">Criar um presente personalizado</div>
        <div class="subtitleGroup">
          Personalize do seu jeito. Insira imagens, valor e a descrição que
          deseja para cada produto.
        </div>
      </div>
      <div
        class="empty-list-card"
        @click="openDrawer(giftReadyInfo, 'DrawerReadyList')"
      >
        <div class="imgGroup"><img :src="readyListImg" /></div>
        <div class="titleGroup">Utilizar uma lista pronta</div>
        <div class="subtitleGroup">
          Destinos de lua de mel, produtos ou experiências? Temos diversas
          listas prontas para você não ter trabalho.
        </div>
      </div>
      <div
        class="empty-list-card"
        @click="openDrawer(giftCategoryInfo, 'DrawerGiftByCategory')"
      >
        <div class="imgGroup"><img :src="chooseGiftImg" /></div>
        <div class="titleGroup">Escolher presentes por categoria</div>
        <div class="subtitleGroup">
          Navegue pelo nosso catálogo de mais de 20.000 itens e selecione
          manualmente os que desejar.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import createGiftImg from '@/assets/img/create_gift.png'
import readyListImg from '@/assets/img/ready_list.png'
import chooseGiftImg from '@/assets/img/choose_gift.png'

export default {
  data() {
    return {
      chooseGiftImg,
      readyListImg,
      createGiftImg,
      giftCreateInfo: {
        title: 'Criar Presente',
        size: 'normal',
      },
      giftCategoryInfo: {
        title: 'Presentes por categoria',
        size: 'big',
      },
      giftReadyInfo: {
        title: 'Utilizar uma lista pronta',
        size: 'big',
      },
    }
  },

  methods: {
    openDrawer(config, component) {
      this.$emit('openDrawer', {
        component,
        config,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.empty-list-section {
  display: block;
  gap: 20px;
  margin-top: 24px;
  margin-bottom: 40px;

  .label-group {
    display: inline-block;
    margin-left: 16px;
    margin-right: 16px;

    @media (max-width: 1024px) {
      display: block;
      text-align: center;
      justify-content: center;
    }

    .title-label {
      font-size: 18px;
      color: $neutraldarkest;
      font-weight: 700;
    }

    .subtitle-label {
      margin-top: 8px;
      font-size: 16px;
      color: #3dafb0;
      font-weight: 400;
    }
  }

  .empty-list-cards-section {
    margin-top: 40px;
    display: grid;
    gap: 24px;
    justify-content: center;

    .empty-list-card {
      width: auto;
      height: 223px;
      background: #ffffff;
      border: 1px solid #dde7f1;
      box-shadow: 0px 10px 15px rgba(93, 117, 141, 0.1);
      border-radius: 16px;
      display: block;
      padding-left: 24px;
      padding-right: 22px;
      padding-top: 24px;
      padding-bottom: 24px;
      margin-left: 16px;
      margin-right: 16px;
      cursor: pointer;
      text-align: left;
      .imgGroup {
        margin-bottom: 20px;
        display: flex;
      }

      .titleGroup {
        color: $neutral;
        font-weight: 700;
        font-size: 16px;
        margin-bottom: 8px;
      }

      .subtitleGroup {
        color: $neutral;
        font-weight: 400;
        font-size: 16px;
        line-height: 20px;
      }
    }

    .empty-list-card:hover {
      background-color: $neutrallightest;
    }
  }
}
</style>
